import {AnchorHTMLAttributes, FC} from 'react';
import clsx from 'clsx';
import {
    BASE_ICON,
    ICON_MARGIN,
    ICON_SIZES,
    Kind,
    KINDS,
    SIZES,
} from 'components/Button';
import Icon from 'components/Icon';
import {IconType} from 'components/Icon/types';
import {useTooltip} from 'components/Tooltip/hook';
import {twMerge} from 'tailwind-merge';
import {Size} from 'types';

export type LinkButtonProps<T = HTMLAnchorElement> = {
    className?: string;
    disabled?: boolean;
    icon?: IconType;
    kind?: Kind;
    size?: Size;
} & AnchorHTMLAttributes<T>;

const LinkButton: FC<LinkButtonProps> = ({
    children,
    className,
    disabled,
    href,
    icon,
    kind = 'tertiary',
    size = 'base',
    ...rest
}) => {
    const {setTooltipRef} = useTooltip();

    return (
        <a
            ref={(r) => setTooltipRef(r)}
            className={twMerge(
                'inline-flex justify-center items-center select-none whitespace-nowrap rounded border hover:no-underline',
                KINDS[kind],
                !icon || children ? SIZES[size] : ICON_SIZES[size],
                className,
            )}
            data-disabled={disabled ? true : undefined}
            href={disabled ? undefined : href}
            tabIndex={disabled ? -1 : undefined}
            {...rest}
        >
            {icon && (
                <Icon
                    className={clsx(
                        children && 'flex-none',
                        children && ICON_MARGIN[size],
                    )}
                    icon={icon}
                    size={BASE_ICON.includes(size) ? 'base' : 'lg'}
                />
            )}
            {children}
        </a>
    );
};

LinkButton.displayName = 'LinkButton';

export default LinkButton;
